<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>
            Stands
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="$refs.dialogoImprimirListagem.abrir()"
            class="mr-2"
          >
            <v-icon>print</v-icon>
          </v-btn>

          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="tooglePesquisa"
          >
            <v-icon>search</v-icon>
          </v-btn>

          <v-btn
            depressed
            color="primary lighten-4"
            @click="$router.push('/rodadas')"
            class="hidden-xs-only ml-2"
            >Voltar</v-btn
          >
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="$router.push('/rodadas')"
            class="hidden-sm-and-up ml-2"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>

          <v-btn
            depressed
            color="primary lighten-4"
            v-if="stands.length == 0 && podeEditar(rodada.data_fim)"
            @click="abrirDialogoCopia"
            class="hidden-xs-only ml-2"
            >Copiar</v-btn
          >
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            v-if="stands.length == 0 && podeEditar(rodada.data_fim)"
            @click="abrirDialogoCopia"
            class="hidden-sm-and-up ml-2"
          >
            <v-icon>file_copy</v-icon>
          </v-btn>

          <v-btn
            depressed
            color="primary lighten-4"
            @click="$router.push('stands/adicionar')"
            class="hidden-xs-only ml-2"
            v-if="podeEditar(rodada.data_fim)"
            >Adicionar</v-btn
          >
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="$router.push('stands/adicionar')"
            class="hidden-sm-and-up ml-2"
            v-if="podeEditar(rodada.data_fim)"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="stands"
          hide-default-footer
          :loading="loading"
        >
          <template v-slot:item.ativa="{ item }">
            {{ item.nome }}
          </template>

          <template v-slot:item.proprietario_nome="{ item }">
            {{ item.proprietario_nome }}
          </template>

          <template v-slot:item.tipo="{ item }">
            {{ item.tipo }}
          </template>

          <template v-slot:item.valor="{ item }">
            R$ {{ item.valor | valorBR }}
          </template>

          <template
            v-slot:item.acoes="{ item }"
            v-if="podeEditar(rodada.data_fim)"
          >
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  @click="$router.push('stands/' + item.id + '/editar')"
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirModalExcluir(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">close</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoExcluir"
        title="Excluir Stand"
        max-width="728px"
        hideCloseButton
      >
        <p>Tem certeza que deseja excluir esse stand?</p>
        <div slot="botoes" class="pa-2">
          <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="excluir"
            :disabled="loading"
            :loading="loading"
            >Excluir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoCopia"
        title="Copiar Stands"
        max-width="728px"
        hideCloseButton
      >
        <v-select
          :items="rodadas"
          label="Selecione a rodada de origem"
          ref="rodada"
          v-model="rodada_copia_id"
          :loading="carregando_rodadas"
          item-text="nome"
          item-value="id"
        ></v-select>
        <div slot="botoes">
          <v-btn color="white" @click="$refs.dialogoCopia.fechar()"
            >Cancelar</v-btn
          >
          <v-btn color="primary" @click="copiarStands" :loading="copiando"
            >Copiar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoImprimirListagem"
        title="Imprimir Listagem de Stands"
        max-width="728px"
        hideCloseButton
      >
        <p>Tem certeza que deseja imprimir a lista de stands?</p>
        <div slot="botoes">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoImprimirListagem.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="imprimirListagem()"
            :disabled="imprimindo"
            :loading="imprimindo"
            >Imprimir</v-btn
          >
        </div>
      </as-dialogo>
    </v-container>
  </div>
</template>

<script>
import ServiceRodadas from "../../services/rodadas.js";
import ServiceImpressoes from "@/services/impressoes.js";

export default {
  name: "Stands",
  data() {
    return {
      loading: false,
      exibirPesquisa: false,
      pesquisa: "",
      user: {},
      headers: [
        { text: "Nome", value: "nome", width: "30%" },
        { text: "Proprietário", value: "proprietario_nome", width: "35%" },
        { text: "Tipo", value: "tipo", width: "20%", class: "hidden-xs-only" },
        { text: "Valor", value: "valor", width: "10%", align: "right" },
        { text: "", value: "acoes", sortable: false, width: "5%" },
      ],
      stands: [],
      stand: {},
      rodadas: [],
      rodada_copia_id: "",
      carregando_rodadas: false,
      copiando: false,
      rodada: {},
      imprimindo: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.listar();
  },
  methods: {
    podeEditar(dataFim) {
      return new Date(dataFim) > new Date();
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      this.loading = true;
      try {
        let result = await ServiceRodadas.carregarStandsRodada(
          this.$route.params.rodada_id
        );
        this.stands = result.data.stands;
        this.rodada = result.data.rodada;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirModalExcluir(stand) {
      this.stand = stand;
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.loading = true;
        let response = await ServiceRodadas.excluirStand(
          this.$route.params.rodada_id,
          this.stand.id
        );
        this.$eventbus.notificar("Stand excluido com sucesso");
        this.listar();
        this.$refs.dialogoExcluir.fechar();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async abrirDialogoCopia() {
      this.carregando_rodadas = true;
      try {
        let result = await ServiceRodadas.carregarRodadasAnteriores(
          this.$route.params.rodada_id
        );
        this.rodadas = result.data.rodadas;
        this.$refs.dialogoCopia.abrir();
      } catch (error) {
        console.log(error);
      } finally {
        this.carregando_rodadas = false;
      }
    },
    async copiarStands() {
      try {
        this.copiando = true;
        await ServiceRodadas.copiarStands(
          this.$route.params.rodada_id,
          this.rodada_copia_id
        );
        this.$eventbus.notificar("Stands copiados com sucesso");
        this.listar();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao copiar stands");
      } finally {
        this.copiando = false;
        this.$refs.dialogoCopia.fechar();
      }
    },
    async imprimirListagem() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.listarStands({
          impressao,
          rodada_id: this.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir listagem de stands");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImprimirListagem.fechar();
      }
    },
  },
};
</script>
